
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import rateConfig from "./components/rate-config.vue";
import qrcodeConfig from "./components/qrcode-config.vue";
import configForm from "./components/config-form.vue";
import msgListDiv from "./components/msg-list-div.vue";
import infoTitle from "@/components/info-title/info-title.vue";
import tio from "@/common/tiows";
import { topicSubscribe, updToken } from "@/api/api-basic-websocket";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-rate-config": rateConfig,
    "pi-qrcode-config": qrcodeConfig,
    "pi-config-form": configForm,
    "pi-info-title": infoTitle,
    "pi-msg-list-div": msgListDiv
  }
})
export default class CollectionDataConfig extends Vue {
  private formInline: objAny = {};
  private gunData: objAny = {};
  private tabsActive = "tab1";
  private msgList: object[] = [];
  private tiows: objAny = {};
  private pilePkId = "";
  private isOpen = 0; // 0 未初始化  1 连接中  2 连接成功  3 连接失败/关闭
  private timer = 0;

  public getContentData(data: objAny, gunData?: objAny) {
    this.formInline = data;
    // this.formInline.pilePkId = "202007140003";
    // this.formInline.gunPkId = "1291540958642114562";
    if (gunData) {
      this.gunData = gunData;
    }
    if (this.formInline.gunPkId == "") {
      this.$Message.error(i18n.t("dataConfig.selectGun"));
    } else {
      if (this.formInline.gunPkId && this.formInline.gunPkId != "") {
        this.topicSubscribe();
      }
      const rateConfig: objAny = this.$refs.rateConfig;
      rateConfig.getFeeByPile(this.formInline.pilePkId);
    }
  }
  async topicSubscribe() {
    const ret = await topicSubscribe({
      pilePkId: this.formInline.pilePkId,
      msgCodes: [2010, 2020, 2100]
    });
    if (ret.status == this["$config"].apiStatus) {
      console.log(i18n.t("dataConfig.subscribeSuccess"));
    }
  }

  public clearMsg() {
    this.msgList = [];
  }

  public init() {
    this.isOpen = 1;
    this.pilePkId = this.formInline.pilePkId;
    this.tiows = new tio.ws({
      onopen: this.onopen,
      onmessage: this.onmessage,
      onclose: this.onclose,
      ping: this.ping,
      onerror: this.onerror
    });
    this.tiows.connect(true);
  }

  public onopen() {
    console.log("连接成功");
    this.isOpen = 2;
  }
  public onmessage(event: objAny) {
    const data = event.data;
    const msgBody = eval("(" + data + ")");
    console.log(msgBody);
    const rateConfig: objAny = this.$refs.rateConfig;
    if (msgBody && msgBody.data) {
      this.msgList.push(msgBody);
    }
    if (msgBody.platformElecFeeItemVos && msgBody.elecFeeItemVos) {
      //召测费率
      rateConfig.getTableList(msgBody);
    }
    const qrcodeConfig: objAny = this.$refs.qrcodeConfig;
    if (msgBody.qrCord) {
      //二维码
      qrcodeConfig.getQrcodeData(msgBody);
    }
    if (msgBody.msgCode == 2100 && msgBody.sender == 1) {
      // 响应
      rateConfig.returnMsgTextData(msgBody.data);
      qrcodeConfig.returnMsgTextData(msgBody.data);
    }
  }
  public onclose() {
    console.log("onclose");
    this.isOpen = 3;
  }
  public ping() {
    // console.log(ws);
  }
  public onerror(ws: objAny, event: objAny) {
    console.log(ws);
    const data = event.data;
    console.log(data);
    // const msgBody = eval("(" + data + ")");
    // console.log(msgBody);
  }

  async updToken() {
    const ret = await updToken();
    if (ret.status == this["$config"].apiStatus) {
      console.log("刷新token成功");
    } else {
      console.log("刷新token失败");
    }
  }
  mounted() {
    this.init();
  }
  created() {
    this.timer = setInterval(this.updToken, 300000);
  }
  beforeDestroy() {
    if (this.timer) {
      //如果定时器还在运行 或者直接关闭，不用判断
      clearInterval(this.timer); //关闭
    }
  }
}
